import React, { FC } from "react";

import { EmissionFactorsTable } from "@components/admin/emissionFactors";
import { Card, CardContent } from "@components/base";

const EmissionFactorsPage: FC = () => {
  return (
    <Card>
      <CardContent>
        <EmissionFactorsTable customEmissionFactors={true} />
      </CardContent>
    </Card>
  );
};

export default EmissionFactorsPage;
